import classnames from 'classnames';
import React, { useContext, useEffect, useState } from 'react';
import {
    Card,
    CardBody,
    Col,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from 'reactstrap';

import { ProjectChangesDateLogList } from '../../../../domain/projectChangesDateLog/ProjectChangesDateLogList';
import { ProjectChangesDateLog } from '../../../../domain/projectChangesDateLog/projectChangesDateLog';
import { ProjectCheckpointsList } from '../../../../domain/projectCheckpoints/projectCheckpointList';
import { Project } from '../../../../domain/projects/project';
import { Private_Routes } from '../../../../main/constants';
import { AppContext } from '../../../../main/context/Provider';
import withFilteredQueryRequest from '../../../shared/components/table/withFilteredRequest';
import OverviewTab from './OverviewTab';
import { ProjectChangesDateLogTab } from './ProjectChangesDateLogTab';
import ProjectCheckpointSection from './ProjectCheckpointSection';
import TeamTab from './TeamTab';
import ProjectLicensesTab from './ProjectLicensesTab';
import { ProjectLicenseList } from '../../../../domain/projectLicenses/ProjectLicenseList';

interface SectionProps {
    project: Project | undefined;
    projectCheckpoints: ProjectCheckpointsList[] | undefined;
    projectLicenses: ProjectLicenseList[] | undefined;
    projectChangesDateLogList: ProjectChangesDateLogList[] | undefined;
    projectChanges: ProjectChangesDateLog | undefined;
}

const Section = ({
    project,
    projectChangesDateLogList,
    projectCheckpoints,
    projectLicenses,
    projectChanges,
}: SectionProps) => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = (tab: React.SetStateAction<string>) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Proyectos',
                route: Private_Routes.PROJECT_PAGE,
            },
            {
                label: project?.name ?? 'Detalles',
                route: `/projects/projects-list/${project?.id}`,
            },
        ]);
    }, [lang]);

    const formatDate = (date: any) => {
        if (!date) return '';

        const formattedDate = new Date(date).toISOString().slice(0, 10);
        return formattedDate;
    };

    const TeamsList = withFilteredQueryRequest(
        `project-checkpoints/${project?.id}/tasks-and-projects-by-employee`,
        TeamTab
    );

    const ProjectLicensesList = withFilteredQueryRequest(
        `projects/${project?.id}/licenses/filter`,
        ProjectLicensesTab
    );
    
    const projectId = project?.id ?? 0;

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Card className='mt-n4 mx-n4'>
                        <div className='bg-light-orange pt-3'>
                            <CardBody className='pb-0 px-4'>
                                <Row className='mb-3'>
                                    <div className='col-md'>
                                        <Row className='align-items-center g-3'>
                                            <div className='col-md'>
                                                <div>
                                                    <h4 className='fw-bold'>
                                                        {project?.name}
                                                    </h4>
                                                    <div className='hstack gap-3 flex-wrap'>
                                                        <i className='ri-building-line align-bottom me-0 fs-20'></i>
                                                        <div>
                                                            {project?.customerName}
                                                        </div>
                                                        <div className='vr'></div>
                                                        <div>
                                                            Fecha Inicial :{' '}
                                                            <span className='fw-semibold'>
                                                                {project?.startDate
                                                                    ? formatDate(
                                                                          project.startDate
                                                                      )
                                                                    : ''}
                                                            </span>
                                                        </div>
                                                        <div className='vr'></div>
                                                        <div>
                                                            Fecha Final :{' '}
                                                            <span className='fw-semibold'>
                                                                {project?.endDate
                                                                    ? formatDate(
                                                                          project.endDate
                                                                      )
                                                                    : ''}
                                                            </span>
                                                        </div>
                                                        <div className='vr'></div>
                                                        <div className='badge rounded-pill bg-success fs-12'>
                                                            <i className='ri-line-chart-line me-2'></i>
                                                            {project?.percentage}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                    </div>
                                </Row>

                                <Nav
                                    className='nav-tabs-custom border-bottom-0'
                                    role='tablist'
                                >
                                    <NavItem>
                                        <NavLink
                                            className={classnames(
                                                { active: activeTab === '1' },
                                                'text-body fw-semibold'
                                            )}
                                            onClick={() => {
                                                toggleTab('1');
                                            }}
                                            href='#'
                                        >
                                            Información
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames(
                                                { active: activeTab === '2' },
                                                'text-body fw-semibold'
                                            )}
                                            onClick={() => {
                                                toggleTab('2');
                                            }}
                                            href='#'
                                        >
                                            Seguimientos
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames(
                                                { active: activeTab === '3' },
                                                'text-body fw-semibold'
                                            )}
                                            onClick={() => {
                                                toggleTab('3');
                                            }}
                                            href='#'
                                        >
                                            Novedades
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames(
                                                { active: activeTab === '4' },
                                                'text-body fw-semibold'
                                            )}
                                            onClick={() => {
                                                toggleTab('4');
                                            }}
                                            href='#'
                                        >
                                            Responsables
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames(
                                                { active: activeTab === '5' },
                                                'text-body fw-semibold'
                                            )}
                                            onClick={() => {
                                                toggleTab('5');
                                            }}
                                            href='#'
                                        >
                                            Licencias
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </CardBody>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <TabContent activeTab={activeTab} className='text-muted'>
                        <TabPane tabId='1'>
                            <OverviewTab project={project} />
                        </TabPane>
                        <TabPane tabId='2'>
                            <ProjectCheckpointSection
                                projectCheckpoints={projectCheckpoints}
                                projectId={project?.id.toString()}
                            />
                        </TabPane>
                        <TabPane tabId='3'>
                            <ProjectChangesDateLogTab
                                projectChangesDateLogList={projectChangesDateLogList}
                                projectChanges={projectChanges}
                            />
                        </TabPane>
                        <TabPane tabId='4'>
                            <TeamsList />
                        </TabPane>
                        <TabPane tabId='5'>
                            <ProjectLicensesList
                             />
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default Section;
